import { Logger } from './types';

export class NullLogger implements Logger {
  debug(e: Error): void;

  debug(message: string, e?: Error | undefined): void;

  debug(): void {
    // NOOP
  }

  info(e: Error): void;

  info(message: string, e?: Error | undefined): void;

  info(): void {
    // NOOP
  }

  warn(e: Error): void;

  warn(message: string, e?: Error | undefined): void;

  warn(): void {
    // NOOP
  }

  error(e: Error): void;

  error(message: string, e?: Error | undefined): void;

  error(): void {
    // NOOP
  }
}
